

import { useState, useEffect , useMemo } from 'react';
import { FaUser, FaVenusMars, FaCalendarAlt, FaMapMarkerAlt, FaPhone, FaWhatsapp, FaBriefcase, FaGlobe, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import { allStates } from 'indian-states-cities';
import countryList from "react-select-country-list";
import baseUrl from '../Config';


const CandidateInquiryForm = () => {
    const options = useMemo(() => countryList().getData(), []);
  const [formData, setFormData] = useState({
    candidateName: '',
    gender: '',
    age: '',
    state: '',
    whatsapp: '',
    additionalPhone: '',
    profession: '',
    country: ''
  });

  console.log('alllllllll' , allStates)

  // Error state
  const [errors, setErrors] = useState({
    candidateName: '',
    gender: '',
    age: '',
    state: '',
    whatsapp: '',
    additionalPhone: '',
    profession: '',
    country: ''
  });

  // Success message state
  const [showSuccess, setShowSuccess] = useState(false);

  // State for radio button selection
  const [selectedGender, setSelectedGender] = useState('');

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  // Handle radio button selection
  const handleGenderSelect = (gender) => {
    setSelectedGender(gender);
    setFormData({
      ...formData,
      gender: gender
    });
    
    // Clear gender error
    if (errors.gender) {
      setErrors({
        ...errors,
        gender: ''
      });
    }
  };

  // Validate form
  const validateForm = () => {
    let valid = true;
    const newErrors = { ...errors };

    // Validate name
    if (!formData.candidateName.trim()) {
      newErrors.candidateName = 'Please enter your full name';
      valid = false;
    }

    // Validate gender
    if (!formData.gender) {
      newErrors.gender = 'Please select your gender';
      valid = false;
    }

    // Validate age
    const age = parseInt(formData.age);
    if (!age || age < 18 || age > 65) {
      newErrors.age = 'Please enter a valid age (18-65)';
      valid = false;
    }

    // Validate state
    if (!formData.state) {
      newErrors.state = 'Please select your state';
      valid = false;
    }

    // Validate WhatsApp number
    const phonePattern = /^[0-9]{10}$/;
    if (!phonePattern.test(formData.whatsapp)) {
      newErrors.whatsapp = 'Enter 10-digit mobile number';
      valid = false;
    }

    // Validate additional phone (if provided)
    if (formData.additionalPhone && !phonePattern.test(formData.additionalPhone)) {
      newErrors.additionalPhone = 'Enter 10-digit mobile number';
      valid = false;
    }

    // Validate profession
    if (!formData.profession.trim()) {
      newErrors.profession = 'Please enter your profession';
      valid = false;
    }

    // Validate country
    if (!formData.country) {
      newErrors.country = 'Please select a country';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  // Handle form submission
const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (validateForm()) {
    try {
      const response = await fetch(`${baseUrl}/candidate-enquiry`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        // Form is valid - show success message
        setShowSuccess(true);
        
        // Reset form
        setFormData({
          candidateName: '',
          gender: '',
          age: '',
          state: '',
          whatsapp: '',
          additionalPhone: '',
          profession: '',
          country: ''
        });
        setSelectedGender('');
        
        // Hide success message after 5 seconds
        setTimeout(() => {
          setShowSuccess(false);
        }, 5000);
      } else {
        // Handle API validation errors
        alert(result.message || 'Failed to submit form');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Network error. Please try again.');
    }
  }
};


  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-green-100 flex items-center justify-center p-4 relative overflow-hidden" style={{ padding: '80px 0px 0px 0px' }}>
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%234bb648' fill-opacity='0.1'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }}></div>
      
      {/* Success message */}
      {showSuccess && (
        <div className="fixed top-4 right-4 bg-white p-4 rounded-lg shadow-lg flex items-center z-50 border-l-4 border-green-500 animate-fade-in-right">
          <FaCheckCircle className="text-green-500 text-xl mr-3" />
          <p className="font-medium text-gray-800">Form submitted successfully! We'll contact you soon.</p>
        </div>
      )}
      
      <div className="relative z-10 w-full max-w-md">
        <div className="bg-white bg-opacity-95 backdrop-blur-lg rounded-2xl shadow-xl overflow-hidden animate-fade-in">
          {/* Form header */}
          <div 
            className="text-white p-6 text-center relative overflow-hidden"
            style={{ background: 'linear-gradient(to right, #4bb648, #4BB648)' }}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-transparent via-white/10 to-transparent transform rotate-45 translate-x-1/2 -translate-y-1/2 w-200 h-200"></div>
            <h1 className="text-2xl font-bold mb-1 relative z-10">Candidate Inquiry Form</h1>
            <p className="text-green-200 relative z-10">Start your journey with us today</p>
          </div>          
          
          {/* Form body */}
          <div className="p-6 md:p-8">
            <form onSubmit={handleSubmit}>
              {/* Candidate Name */}
              <div className="mb-5">
                <label className="flex items-center font-semibold text-gray-800 mb-2 text-sm">
                  <FaUser className="text-green-500 mr-2" /> Candidate Name
                </label>
                <div className="relative">
                  <input
                    type="text"
                    name="candidateName"
                    value={formData.candidateName}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    className={`w-full px-4 py-3 border-2 rounded-lg text-base focus:outline-none transition-all ${
                      errors.candidateName 
                        ? 'border-red-500 bg-red-50' 
                        : 'border-gray-200 focus:border-green-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(75,182,72,0.1)]'
                    }`}
                  />
                  {errors.candidateName && (
                    <div className="mt-1 text-red-500 text-sm flex items-center animate-fade-in">
                      <FaExclamationCircle className="mr-1" /> {errors.candidateName}
                    </div>
                  )}
                </div>
              </div>
              
              {/* Gender */}
              <div className="mb-5">
                <label className="flex items-center font-semibold text-gray-800 mb-2 text-sm">
                  <FaVenusMars className="text-green-500 mr-2" /> Gender
                </label>
                <div className="flex gap-3 mt-2">
                  {['male', 'female', 'other'].map((gender) => (
                    <div
                      key={gender}
                      onClick={() => handleGenderSelect(gender)}
                      className={`flex-1 flex items-center justify-center p-3 rounded-lg cursor-pointer transition-all ${
                        selectedGender === gender
                          ? 'bg-green-100 border-2 border-green-500'
                          : 'bg-gray-100 hover:bg-gray-200'
                      }`}
                    >
                      <input
                        type="radio"
                        name="gender"
                        value={gender}
                        checked={selectedGender === gender}
                        onChange={() => {}}
                        className="mr-2"
                      />
                      <label className="capitalize cursor-pointer">{gender}</label>
                    </div>
                  ))}
                </div>
                {errors.gender && (
                  <div className="mt-1 text-red-500 text-sm flex items-center animate-fade-in">
                    <FaExclamationCircle className="mr-1" /> {errors.gender}
                  </div>
                )}
              </div>
              
              {/* Age */}
              <div className="mb-5">
                <label className="flex items-center font-semibold text-gray-800 mb-2 text-sm">
                  <FaCalendarAlt className="text-green-500 mr-2" /> Age
                </label>
                <div className="relative">
                  <input
                    type="number"
                    name="age"
                    value={formData.age}
                    onChange={handleChange}
                    placeholder="Enter your age"
                    min="18"
                    max="65"
                    className={`w-full px-4 py-3 border-2 rounded-lg text-base focus:outline-none transition-all ${
                      errors.age 
                        ? 'border-red-500 bg-red-50' 
                        : 'border-gray-200 focus:border-green-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(75,182,72,0.1)]'
                    }`}
                  />
                  {errors.age && (
                    <div className="mt-1 text-red-500 text-sm flex items-center animate-fade-in">
                      <FaExclamationCircle className="mr-1" /> {errors.age}
                    </div>
                  )}
                </div>
              </div>
              
            
             {/* State */}
<div className="mb-5">
  <label className="flex items-center font-semibold text-gray-800 mb-2 text-sm">
    <FaMapMarkerAlt className="text-green-500 mr-2" /> State/Union Territory in India
  </label>
  <div className="relative">
    <select
      name="state"
      value={formData.state}
      onChange={handleChange}
      className={`w-full px-4 py-3 border-2 rounded-lg text-base focus:outline-none transition-all appearance-none ${
        errors.state 
          ? 'border-red-500 bg-red-50' 
          : 'border-gray-200 focus:border-green-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(75,182,72,0.1)]'
      }`}
    >
      <option value="">Select your state/UT</option>
      {allStates().map((state) => (
        console.log('stateeeeee' , state),
        <option key={state} value={state}>
          {state}
        </option>
      ))}
    </select>
  </div>
</div>

              
              {/* Phone numbers */}
             <div className="mb-5">
  <label className="flex items-center font-semibold text-gray-800 mb-2 text-sm">
    <FaPhone className="text-green-500 mr-2" /> Contact Information
  </label>
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
    
    {/* WhatsApp Number */}
    <div className="relative">
      {/* <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
        <FaWhatsapp className={`text-gray-400 ${errors.whatsapp ? 'text-red-500' : ''}`} />
      </div> */}
      <input
        type="tel"
        name="whatsapp"
        value={formData.whatsapp}
        onChange={handleChange}
        placeholder="WhatsApp number"
        pattern="[0-9]{10}"
        className={`w-full pl-4 pr-4 py-3 border-2 rounded-lg text-base focus:outline-none transition-all ${
          errors.whatsapp 
            ? 'border-red-500 bg-red-50' 
            : 'border-gray-200 focus:border-green-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(75,182,72,0.1)]'
        }`}
      />
      {errors.whatsapp && (
        <div className="mt-1 text-red-500 text-sm flex items-center animate-fade-in">
          <FaExclamationCircle className="mr-1" /> {errors.whatsapp}
        </div>
      )}
    </div>

    {/* Additional Phone */}
    <div className="relative">
      {/* <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
        <FaPhone className={`text-gray-400 ${errors.additionalPhone ? 'text-red-500' : ''}`} />
      </div> */}
      <input
        type="tel"
        name="additionalPhone"
        value={formData.additionalPhone}
        onChange={handleChange}
        placeholder="Additional phone"
        pattern="[0-9]{10}"
        className={`w-full pl-4 pr-4 py-3 border-2 rounded-lg text-base focus:outline-none transition-all ${
          errors.additionalPhone 
            ? 'border-red-500 bg-red-50' 
            : 'border-gray-200 focus:border-green-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(75,182,72,0.1)]'
        }`}
      />
      {errors.additionalPhone && (
        <div className="mt-1 text-red-500 text-sm flex items-center animate-fade-in">
          <FaExclamationCircle className="mr-1" /> {errors.additionalPhone}
        </div>
      )}
    </div>
  </div>
</div>

              
              {/* Profession */}
              <div className="mb-5">
                <label className="flex items-center font-semibold text-gray-800 mb-2 text-sm">
                  <FaBriefcase className="text-green-500 mr-2" /> Profession
                </label>
                <div className="relative">
                  <input
                    type="text"
                    name="profession"
                    value={formData.profession}
                    onChange={handleChange}
                    placeholder="Enter your profession"
                    className={`w-full px-4 py-3 border-2 rounded-lg text-base focus:outline-none transition-all ${
                      errors.profession 
                        ? 'border-red-500 bg-red-50' 
                        : 'border-gray-200 focus:border-green-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(75,182,72,0.1)]'
                    }`}
                  />
                  {errors.profession && (
                    <div className="mt-1 text-red-500 text-sm flex items-center animate-fade-in">
                      <FaExclamationCircle className="mr-1" /> {errors.profession}
                    </div>
                  )}
                </div>
              </div>
              
              {/* Country */}
             <div className="mb-6">
      <label className="flex items-center font-semibold text-gray-800 mb-2 text-sm">
        <FaGlobe className="text-green-500 mr-2" /> Country Looking For
      </label>
      <div className="relative">
        <select
          name="country"
          value={formData.country}
          onChange={handleChange}
          className={`w-full px-4 py-3 border-2 rounded-lg text-base focus:outline-none transition-all appearance-none ${
            errors.country
              ? "border-red-500 bg-red-50"
              : "border-gray-200 focus:border-green-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(75,182,72,0.1)]"
          }`}
        >
          <option value="">Select a country</option>
          {options.map((country) => (
            <option key={country.value} value={country.label}>
              {country.label}
            </option>
          ))}
        </select>

        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <svg
            className="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
          </svg>
        </div>

        {errors.country && (
          <div className="mt-1 text-red-500 text-sm flex items-center animate-fade-in">
            <FaExclamationCircle className="mr-1" /> {errors.country}
          </div>
        )}
      </div>
    </div>
              
              {/* Submit button */}
              <button
  type="submit"
  className="w-full py-4 bg-[#4BB648] hover:bg-[#3da73a] text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 relative overflow-hidden group"
>
  <span className="relative z-10">Submit Inquiry</span>
  <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-500"></span>
</button>
            </form>
          </div>
        </div>
      </div>
      
      {/* Custom animations */}
      <style jsx global>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes fade-in-right {
          from { opacity: 0; transform: translateX(20px); }
          to { opacity: 1; transform: translateX(0); }
        }
        
        .animate-fade-in {
          animation: fade-in 0.5s ease-out;
        }
        
        .animate-fade-in-right {
          animation: fade-in-right 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default CandidateInquiryForm;